import { routeCreator } from '@adrias-online/steiner';
import _ from 'lodash';

import { generateRoutes } from '../../../helpers/hotelModuleHelper';
import routeRegister from '../../../helpers/routeRegister';
import { selectors } from '../reducers/mediaGallery';

const patternMediaGallery = '/hotel/:id/mediaGallery';

const routes = generateRoutes('mediaGallery', selectors);

routes.list.list = {
    breadcrumb: 'Media Gallery',
    componentPath: 'containers/MediaGalleryListLayout',
    path: patternMediaGallery,
    hotelFilter: true
};

const list = _.values(routes.list).map(route => ({
    ...route,
    hotelFilter: true,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'mediaGallery' */ `modules/mediaGallery/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));



const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('mediaGallery', routes.patterns);
routeRegister.addLinks('mediaGallery', links);

export default list;